import client from './axios'

export type DigestFrequency = 'daily' | 'weekly' | 'off'

export type EmailSettings = {
  digest_frequency: DigestFrequency
  new_updates: boolean
  answer_challenged: boolean
}

export async function getEmailSettings(
  signal?: AbortSignal,
): Promise<EmailSettings> {
  const { data } = await client.get('/accounts/email_settings/me/', { signal })

  return data
}

export async function updateEmailSettings(
  payload: Partial<EmailSettings>,
): Promise<EmailSettings> {
  const { data } = await client.patch('/accounts/email_settings/me/', payload)

  return data
}
